import React, { useRef } from 'react'
import './Services.css'
import wdd from '../../../../assets/img/wdd.svg'
import mbd from '../../../../assets/img/mbd.svg'
import csd from '../../../../assets/img/csd.svg'
import ecd from '../../../../assets/img/ecd.svg'
import sd from '../../../../assets/img/sd.svg'
import dt from '../../../../assets/img/dt.svg'
import { Link } from 'react-router-dom'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function Services() {

  const servicesRef = useRef(null)
  const headingRef = useRef(null)
  const badgeRef = useRef(null)
  const scrambleChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'

  const handleClick =()=>{
    window.scrollTo(0,0);
  }

  const servicedate = [
    {
        img: wdd,
        title: "Website Design & Developemnt",
        desc: "We offers robust & scalable web application development.",
        link: "/web-application-development"
    },
    {
        img: mbd,
        title: "Mobile Application Development",
        desc: "We are passionate and innovative, our mobile app developers are striving to serve businesses with robust IT solutions to build amazing products with the right mix of qualities.",
        link: "/mobile-application-development"
    },
    {
        img: csd,
        title: "Custom Software Development",
        desc: "Our custom software development services are benchmarks when it comes to uplifting businesses to new achievements and success.",
        link: "/custom-software-development"
    },
    {
        img: ecd,
        title: "E-Commerce Development",
        desc: "360Bytes offers great solutions that enable retail stores to move on the online market space and reap the benefits on offer.",
        link: "/e-commerce-development"
    },
    {
        img: sd,
        title: "SaaS Development",
        desc: "The Software as a Service (SaaS) distribution model lets users access applications hosted online, thus freeing them from possible installation, maintenance or integration issues. ",
        link: "/saas-development"
    },
    {
        img: dt,
        title: "Digital Transformation",
        desc: "A digital transformation drastically changes existing business practices by converting physical formats into digital technology.",
        link: "/web-application-development"
    },
]  

  useGSAP(() => {
    const scoped = headingRef.current

    if (!scoped) {
      return
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    if (prefersReducedMotion) {
      gsap.set(scoped.children, { clearProps: 'all' })
      return
    }

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: scoped,
        start: 'top 50%',
        once: true
      }
    })

    tl.from(scoped.querySelector('h5'), {
      autoAlpha: 0,
      y: 50,
      duration: 0.6,
      ease: 'power3.out'
    }).from(scoped.querySelector('h3'), {
      autoAlpha: 0,
      y: 70,
      duration: 0.7,
      ease: 'power3.out'
    }, '-=0.2')
  }, { dependencies: [] })

  useGSAP(() => {
    const list = servicesRef.current?.querySelectorAll('li')

    if (!list?.length) {
      return
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    if (prefersReducedMotion) {
      gsap.set(list, { clearProps: 'all' })
      return
    }

    const tween = gsap.fromTo(
      list,
      {
        autoAlpha: 0,
        y: 0,
        scale: 0.5
      },
      {
        autoAlpha: 1,
        y: 0,
        scale: 1,
        duration: 0.9,
        delay: 0.5,
        ease: 'power3.out',
        stagger: 0.12,
        scrollTrigger: {
          trigger: servicesRef.current,
          start: 'top 50%',
          once: true,
          toggleActions: 'play none none reverse'
        }
      }
    )

    return () => {
      tween?.kill()
    }
  }, { dependencies: [] })

  useGSAP(() => {
    const badge = badgeRef.current

    if (!badge) {
      return
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    if (prefersReducedMotion) {
      return
    }

    const original = badge.dataset.content || badge.textContent || ''
    const scrambleState = { progress: 0 }

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: badge,
        start: 'top 50%',
        once: true
      },
      onComplete: () => {
        badge.textContent = original
        badge.setAttribute('data-content', original)
      },
      onInterrupt: () => {
        badge.textContent = original
        badge.setAttribute('data-content', original)
      }
    })

    timeline.from(badge, {
      autoAlpha: 0,
      y: 40,
      duration: 0.6,
      ease: 'power3.out'
    })

    timeline.to(scrambleState, {
      progress: 1,
      duration: 1.3,
      ease: 'power1.out',
      onUpdate: () => {
        // Batch DOM reads and writes to avoid forced reflows
        requestAnimationFrame(() => {
          const revealCount = Math.floor(scrambleState.progress * original.length)
          let output = ''

          for (let i = 0; i < original.length; i += 1) {
            const currentChar = original[i]

            if (currentChar === ' ' || currentChar === '\n') {
              output += currentChar
            } else if (i < revealCount) {
              output += currentChar
            } else {
              const randomIndex = Math.floor(Math.random() * scrambleChars.length)
              output += scrambleChars[randomIndex]
            }
          }

          // Batch DOM writes together
          badge.textContent = output
          badge.setAttribute('data-content', output)
        })
      }
    }, '<')

    return () => {
      timeline.kill()
      badge.textContent = original
      badge.setAttribute('data-content', original)
    }
  }, { dependencies: [] })

  return (
    <section className='hm-services'>
      <div className='container'>  
       <div className='head-ing' data-content='Services' ref={badgeRef}>Services</div> 
       <div className='mn-head' ref={headingRef}> 
         <h5>Our Services</h5>
         <h3>We enable innovation</h3>
       </div>
       <ul ref={servicesRef}>
        {
           servicedate.map((Services, index)=>(
            <li key={index}>
            <Link to={Services.link} onClick={handleClick}> 
             <div className='ser-icon'><img src={Services.img} alt={Services.title} width={80} height={80} loading="lazy"></img></div>
             <h4>{Services.title}</h4>  
             <p>{Services.desc}</p>  
            </Link>   
          </li>
           )) 
        }
            

       </ul>
      </div> 
    </section>
  )
}

export default Services
